/*
This method is used to ensure equal functionality between the CommentInput and RobotoMarkdown components.
RobotoMarkdown, by default, will not render a link if there is a space in the url. It will be a <p>. 
CommentInput, which uses react-mentions, will render a link with a space in the url. This method is used to 
remove the space in the url so that the link will be rendered correctly in RobotoMarkdown.
*/
export const fixTimestampLinks = (text: string) => {
  return text.replace(/\(timestamp:\s{1,3}(\d+(\.\d+)?)\)/g, "(timestamp:$1)");
};
